// src/services/PaymentServiceMock.js
// This is a mock version of the PaymentService for local testing with no database operations

// Store mock payment data in memory during the session
const mockPayments = [];
const mockPurchasers = {}; // Format: { listingId: [userId1, userId2, ...] }

// Initialize Stripe mock
let stripePromise = null;
export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripeMock();
  }
  return stripePromise;
};

// Load a mock Stripe for testing
function loadStripeMock() {
  return new Promise((resolve) => {
    // Create a mock Stripe instance
    const mockStripe = {
      elements: () => ({
        create: (type) => {
          // Create a mock card element
          const mockElement = {
            mount: (elementId) => {
              // Simulate mounting by adding a mock element
              setTimeout(() => {
                const element = document.getElementById(elementId);
                if (element) {
                  element.innerHTML = '<div style="padding: 10px; border: 1px solid #ccc; border-radius: 4px; background: #f8f9fb;">Mock Card Element (Testing Mode)<br>Use any values - this is a simulation</div>';
                }
              }, 100);
            },
            // Add destroy method that mock elements need
            destroy: () => {
              console.log('Mock element destroyed');
              // This is a no-op in the mock version
            },
            // Add other methods that might be called
            on: (event, callback) => {
              // No-op for event listeners
              return mockElement;
            },
            update: (options) => {
              // No-op for updates
              return mockElement;
            }
          };
          
          return mockElement;
        }
      }),
      confirmCardPayment: (clientSecret, options) => {
        return new Promise((resolve) => {
          // Simulate processing time
          setTimeout(() => {
            resolve({
              paymentIntent: {
                id: 'mock_payment_' + Date.now(),
                status: 'succeeded'
              }
            });
          }, 1500);
        });
      }
    };
    
    resolve(mockStripe);
  });
}

// Mock function to create payment intent - completely local, no API calls
export const createPaymentIntent = async (listingId, amount, userId, listerEmail, quantity = 1) => {
  console.log('Creating mock payment intent for:', { listingId, amount, userId, listerEmail });
  
  // Simulate a network delay
  await new Promise(resolve => setTimeout(resolve, 800));
  
  // Return a mock client secret
  return {
    clientSecret: 'mock_secret_' + Math.random().toString(36).substring(2, 15),
    paymentIntentId: 'mock_intent_' + Date.now()
  };
};

// Record the payment in memory (no Firestore operations)
export const recordPayment = async (paymentData) => {
  try {
    const { 
      listingId, 
      userId, 
      amount, 
      paymentIntentId, 
      status,
      listerEmail, // Accept lister email in payment data
      quantity = 1
    } = paymentData;

    // Generate a mock ID for the payment
    const paymentId = 'mock_payment_record_' + Date.now();
    
    // Store in our mock database
    const paymentRecord = {
      id: paymentId,
      listingId,
      userId,
      amount,
      quantity,
      paymentIntentId,
      listerEmail, // Store lister email in mock payment record
      status,
      createdAt: new Date().toISOString()
    };
    
    mockPayments.push(paymentRecord);
    console.log('Mock payment recorded:', paymentRecord);

    // If payment is successful, update mock purchasers list
    if (status === 'succeeded') {
      if (!mockPurchasers[listingId]) {
        mockPurchasers[listingId] = [];
      }
      
      // Only add the user once
      if (!mockPurchasers[listingId].includes(userId)) {
        mockPurchasers[listingId].push(userId);
      }
      
      console.log('Mock purchasers updated:', mockPurchasers);
    }

    return paymentId;
  } catch (error) {
    console.error('Error recording mock payment:', error);
    throw error;
  }
};

// Check if a user has purchased a listing (for the mock)
export const hasUserPurchased = (listingId, userId) => {
  return mockPurchasers[listingId] && mockPurchasers[listingId].includes(userId);
};

// Returns mock payments for debugging
export const getMockPayments = () => {
  return [...mockPayments];
};
